<template>
    <div class="listmain ">
        <!--<h1 class="firTitle">协议简介</h1>-->
        <h3>
            <div>
                <span class="firTitle">设备发现payload协议说明</span>
            </div>
        </h3>
        <p>
            <span class="ql-author-7802039 ql-size-9">payload 协议参数说明：</span>
        </p>
        <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
            <tbody>
            <tr>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    参数名
                </td>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    参数类型
                </td>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    参数说明
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    devices
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    JSON Object List
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    用户设备列表
                </td>
            </tr>
            </tbody>
        </table>
        <p>
            <span class="ql-author-7802039 ql-size-9">JSON Object 对象说明:</span>

        </p>
        <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
            <tbody>
            <tr>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    参数名
                </td>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    参数类型
                </td>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    参数说明
                </td>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    返回值是否允许为空
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    deviceId
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    String
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    设备Id
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    否
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    deviceType
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    String
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    设备类型,具体参考OrionOS支持的品类列表
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    否
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    deviceName
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    String
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    名称
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    否
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    brand
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    String
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    品牌
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    否
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    model
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    String
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    型号
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    否
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    zone
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    String
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    位置
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    可选
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    icon
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    String
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    产品icon(https协议的url链接),像素最好160*160 以免在app显示模糊
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    否
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    properties
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    JSON List
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    返回当前设备支持的属性状态列表,产品支持的属性列表参考附录3
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    否
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    actions
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    List&nbsp;
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    产品支持的操作(注：包括支持的查询操作) ,详情参照 协议简介 中 1.3.2和1.3.3章节
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    否(万能遥控器除外)
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    online
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    int
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    1表示在线0表示不在线,不传输则认为在线
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    可选
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    extensions
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    Object
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    产品扩展属性,为空返回null或者不返回该字段
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    可选
                </td>
            </tr>
            </tbody>
        </table>
        <span>
<p>
	<span class="ql-author-7802039 ql-size-9">注：</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">1.位置取值可参考附录4 位置列表</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">2.设备支持的actions 需要按照设备的实际情况将支持的操作返回,我们会根据Actions的返回进行控制请求过滤,请开发商务必返回实际的操作actions</span>
</p>
</span>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
            display: inline-block;
            margin: 20px 0;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/Zn_sb_payload.vue